import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import authenticationUtils from '../../utils/authenticationUtils';
import { PaymentUser } from '../../types/userType';

export const getPaymentUser = async (): Promise<PaymentUser> => {
  const url = `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/users/me`;
  const { data } = await httpGet(url, {
    headers: {
      Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
    }
  });
  return data as PaymentUser;
};

const paymentUsersApi = { getPaymentUser };
export default paymentUsersApi;
